import { render, staticRenderFns } from "./InfoCostoDesarmadero.vue?vue&type=template&id=6a372b56&"
import script from "./InfoCostoDesarmadero.vue?vue&type=script&lang=js&"
export * from "./InfoCostoDesarmadero.vue?vue&type=script&lang=js&"
import style0 from "./InfoCostoDesarmadero.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VIcon})
